<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Tips-callout
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Teal-tonad informationsruta med glödlampsikon. Används i receptguider och
      teknikartiklar för tips och råd.
    </p>

    <PreviewFull label="Exempel">
      <div
        class="w-full flex gap-3 p-5 rounded-2xl"
        style="
          background: rgba(20, 184, 166, 0.06);
          border: 1px solid rgba(20, 184, 166, 0.18);
        "
      >
        <div class="flex-shrink-0 mt-0.5">
          <Lightbulb :size="20" color="#14b8a6" />
        </div>
        <div>
          <p class="font-[Poppins] font-bold text-[14px] text-[#191c1e] mb-1">
            Tips
          </p>
          <p
            class="font-[Plus_Jakarta_Sans] text-[14px] text-[#3c4947] leading-[1.6] m-0"
          >
            Längre autolys – 30–60 minuter – ger ett mer elastiskt glutennät och
            gör degen mer formbar. Prova detta om din deg känns stram och
            svårarbetad.
          </p>
        </div>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { Lightbulb } from "lucide-vue-next";
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div class="flex gap-3 p-5 rounded-2xl"
  style="background: rgba(20,184,166,0.06); border: 1px solid rgba(20,184,166,0.18)">
  <Lightbulb :size="20" color="#14b8a6" class="flex-shrink-0 mt-0.5" />
  <div>
    <p class="font-[Poppins] font-bold text-[14px] text-[#191c1e] mb-1">Tips</p>
    <p class="font-[Plus_Jakarta_Sans] text-[14px] text-[#3c4947] leading-[1.6] m-0">
      Din tips-text här.
    </p>
  </div>
</div>`;

const cssCode = `/* Bakgrund */
background: rgba(20,184,166,0.06);

/* Kant */
border: 1px solid rgba(20,184,166,0.18);

/* Radie */
border-radius: 16px;   /* rounded-2xl */

/* Ikon: Lightbulb (lucide-vue-next), 20px, color #14b8a6 */

/* Rubrik */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 14px;

/* Brödtext */
font-family: 'Plus Jakarta Sans', sans-serif;
font-size: 14px;
color: #3c4947;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
